import React, { useState } from 'react';
import '../../../entrydoor.css';

const GlassDividersSideLiteEticom = ({ value, label = 'Glass Dividers:', childs = [], onChange, disabled = false }) => { // Set default value for childs
    const [selectedGlassDividersSideLiteEticom, setSelectedGlassDividersSideLiteEticom] = useState(value || "None");

    const handleGlassDividersSideLiteEticomChange = (e) => {
        const newValue = e.target.value;
        setSelectedGlassDividersSideLiteEticom(newValue);
        onChange(e.target.value);

        // Dynamically fetch and modify styles for dependent controls if any exist
        if (Array.isArray(childs) && childs.length > 0) {
            childs.forEach((childId) => {
                const element = document.getElementById(childId);
                if (element) {
                    element.style.display = newValue === "Grills" ? "block" : "none";
                    const label = element.previousElementSibling; // Fetch the label, if present
                    if (label) {
                        label.style.display = newValue === "Grills" ? "block" : "none";
                    }
                }
            });
        }
    };

    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor="GlassDividersSideLiteEticom">{label}</label>
            <select
                disabled={disabled}
                id="GlassDividersSideLiteEticom"
                value={selectedGlassDividersSideLiteEticom}
                onChange={handleGlassDividersSideLiteEticomChange}
            >
                <option value='None'>{selectedGlassDividersSideLiteEticom === 'None' ? 'None ✔' : 'None'}</option>
                <option value='Grills'>{selectedGlassDividersSideLiteEticom === 'Grills' ? 'Grills ✔' : 'Grills'}</option>
            </select>
        </div>
    );
};

export default GlassDividersSideLiteEticom;
